import React from 'react';
import type { Data } from 'types';

import { CLUSTER_HEADER_CATEGORY } from '../../utils/constant';

import CareerClusterHeader from './careerClusterHeader/CareerClusterHeader';
import CareerComboClusterHeader from './careerComboClusterHeader/CareerComboClusterHeader';
import CareerComboSalaryClusterHeader from './careerComboSalaryClusterHeader/CareerComboSalaryClusterHeader';
import CareerSalaryClusterHeader from './careerSalaryClusterHeader/careerSalaryHeader';
import CityClusterHeader from './cityClusterHeader/CityClusterHeader';
import CompanyClusterHeader from './companyClusterHeader/CompanyClusterHeader';
import CompanySalaryClusterHeader from './companySalaryClusterHeader/CompanySalaryClusterHeader';
import JobSearchForeignWorkersClusterHeader from './jobSearchForeignWorkersClusterHeader/jobSearchForeignWorkersClusterHeader';
import JobSearchHighSchoolClusterHeader from './JobSearchhighSchoolClusterHeader/highSchoolClusterHeader';
import JobSearchLGBTQClusterHeader from './jobSearchLGBTQClusterHeader/jobSearchLGBTQClusterHeader';
import JobSearchRemoteClusterHeader from './jobSearchRemoteClusterHeader/JobSearchRemoteClusterHeader';
import MajorClusterHeader from './majorClusterHeader/MajorClusterHeader';
import { JobSearchClusterHeader } from './jobSearchClusterHeader';

type ClusterHeaderProps = {
  data: Data; // We could extend it in the future to get better types validation for each cluster type
  subPageName: string;
  clusterCategory: string;
  subTitle?: string;
  headerTitle?: string;
  subPageTextSmall?: boolean;
};

const ClusterHeader: React.FC<ClusterHeaderProps> = ({
  data,
  subPageName,
  clusterCategory,
  subTitle,
  headerTitle,
  subPageTextSmall,
}) => {
  switch (clusterCategory) {
    case CLUSTER_HEADER_CATEGORY.CAREER:
      return (
        <CareerClusterHeader
          subPageName={subPageName}
          subTitle={subTitle}
          subPageTextSmall={subPageTextSmall}
          {...data}
        />
      );
    case CLUSTER_HEADER_CATEGORY.COMPANY:
      return <CompanyClusterHeader subPageName={subPageName} subTitle={subTitle} {...data} />;
    case CLUSTER_HEADER_CATEGORY.COMPANY_FAQ:
      return <CompanyClusterHeader subPageName={subPageName} subTitle={subTitle} {...data} />;
    case CLUSTER_HEADER_CATEGORY.CAREER_COMBO:
      return <CareerComboClusterHeader subPageName={subPageName} subTitle={subTitle} {...data} />;
    case CLUSTER_HEADER_CATEGORY.MAJOR:
      return <MajorClusterHeader subPageName={subPageName} {...data} />;
    case CLUSTER_HEADER_CATEGORY.REMOTE:
      return (
        <JobSearchRemoteClusterHeader
          subPageName={subPageName}
          headerTitle={headerTitle}
          {...data}
        />
      );
    case CLUSTER_HEADER_CATEGORY.CAREER_SALARY:
      return (
        <CareerSalaryClusterHeader
          subPageName={subPageName}
          {...data}
          subPageTextSmall={subPageTextSmall}
          clusterCategory={clusterCategory}
        />
      );
    case CLUSTER_HEADER_CATEGORY.CAREER_COMBO_SALARY:
      return (
        <CareerComboSalaryClusterHeader subPageName={subPageName} subTitle={subTitle} {...data} />
      );
    case CLUSTER_HEADER_CATEGORY.COMPANY_SALARY:
      return <CompanySalaryClusterHeader subPageName={subPageName} {...data} />;
    case CLUSTER_HEADER_CATEGORY.LGBTQ:
      return (
        <JobSearchLGBTQClusterHeader
          subPageName={subPageName}
          headerTitle={headerTitle}
          {...data}
        />
      );
    case CLUSTER_HEADER_CATEGORY.FOREIGN_WORKERS:
      return (
        <JobSearchForeignWorkersClusterHeader
          subPageName={subPageName}
          headerTitle={headerTitle}
          {...data}
        />
      );
    case CLUSTER_HEADER_CATEGORY.HIGH_SCHOOL:
      return (
        <JobSearchHighSchoolClusterHeader
          subPageName={subPageName}
          headerTitle={headerTitle}
          {...data}
        />
      );
    case CLUSTER_HEADER_CATEGORY.JOB_SEARCH:
      return (
        <JobSearchClusterHeader subPageName={subPageName} headerTitle={headerTitle} {...data} />
      );
    case CLUSTER_HEADER_CATEGORY.CITY:
      return (
        <CityClusterHeader
          subTitle={subTitle}
          subPageName={subPageName}
          headerTitle={headerTitle}
          {...data}
        />
      );
    default:
      return null;
  }
};

export default ClusterHeader;
